export const { REACT_APP_API_BASE: API_BASE } = process.env;
export const { REACT_APP_ADMIN: API_ADMIN } = process.env;
export const { REACT_APP_ADMIN_V3: API_ADMIN3 } = process.env;
export const { REACT_APP_IMAGE_BASE: API_IMAGE_BASE } = process.env;

export const cmsPage = {
  PrivacyPolicy: "privacyPolicy",
  TermsAndCondition: "termsAndCondition",
  CancellationPolicy: "cancellationPolicy",
  ContactDetails: "contactDetails",
};

export const roleType = {
  Dealer: "dealer",
  Customer: "customer",
  Manufacturer: "manufacturer",
  Admin: "admin",
};

// export function calculateTotalAmount(order) {
//   if (!order || !order.product || !Array.isArray(order.product)) return 0;

//   const GST_RATE = order?.sta_commission?.gstRate / 100;
//   const serviceRate = order?.sta_commission?.manufacturerRate
//     ? order?.sta_commission?.manufacturerRate
//     : order?.sta_commission?.dealerRate;

//   let totalAmount = 0;

//   order.product.forEach((item) => {
//     console.log('total item item: ', item);
//     if (item.status !== 4 && item.quantity != null) {
//       const perPrice = parseFloat(item.perPrice || "0");
//       const quantity = parseFloat(item.quantity || "0");
//       const baseAmount = perPrice * quantity;

//       const gstAmount = baseAmount * GST_RATE;
//       const gstTotal = baseAmount + gstAmount;
//       const serviceCommission = gstTotal * (serviceRate / 100);

//       const finalAmount = gstTotal + serviceCommission;
//       totalAmount += finalAmount;
//     }
//   });

//   return totalAmount.toFixed(2); // return as string with 2 decimal places
// }

export function calculateTotalAmount(order) {
  if (!order || !Array.isArray(order.product)) return 0;

  const GST_RATE = parseFloat(order?.sta_commission?.gstRate || 0) / 100;
  const serviceRate = parseFloat(
    order?.sta_commission?.manufacturerRate ??
    order?.sta_commission?.dealerRate ??
    0
  );

  let totalAmount = 0;

  order.product.forEach((item) => {
    console.log('item: ', item);
    if (Array.isArray(item.manufacturerBrand)) {
      item.manufacturerBrand.forEach((brand) => {
        if (brand.statusOrder !== 4 && brand.quantity != null) {
          const perPrice = parseFloat(brand.perPrice || "0");
          const quantity = parseFloat(brand.quantity || "0");
          const baseAmount = perPrice * quantity;

          const gstAmount = baseAmount * GST_RATE;
          const gstTotal = baseAmount + gstAmount;
          const serviceCommission = gstTotal * (serviceRate / 100);
          const finalAmount = gstTotal + serviceCommission;

          totalAmount += finalAmount;

          console.log(`  → Brand Entry:`, {
            quantity,
            perPrice,
            baseAmount,
            gstAmount,
            serviceCommission,
            finalAmount
          });
        }
      });
    }
  });

  return totalAmount.toFixed(2); // string with 2 decimals
}
